/**
 * Generates a unique identifier string combining timestamp and random components
 * @returns {string} A unique identifier in the format: obj-{timestamp}-{randomString}
 * 
 * Implementation details:
 * - Uses current timestamp (Date.now()) as primary uniqueness factor
 * - Adds random string component using base-36 encoding for compactness
 * - Combines both parts with hyphens for readability
 * - Example output: "obj-1703123456789-abc123def"
 */
export const generateUniqueId = (): string => {
  return `obj-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
};
